import { render, staticRenderFns } from "./MyCard.vue?vue&type=template&id=58cbb5d8"
import script from "./MyCard.vue?vue&type=script&lang=js"
export * from "./MyCard.vue?vue&type=script&lang=js"
import style0 from "./MyCard.vue?vue&type=style&index=0&id=58cbb5d8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports